<template>
    <div class="tr">
        <span class="td">{{index}}</span>
        <span class="td">{{user.username}}</span>
        <span class="td">{{user.secondName}} {{user.firstName}}</span>
        <span class="td">{{$t(`roles.${user.role}`)}}</span>
        <span class="td">
            {{$t('general.selectedGroups')}}: {{groups.length}}
        </span>
        <span class="td status">
            <font-awesome-icon class="active" icon="check-circle" size="lg" v-if="isActive"/>
            <font-awesome-icon class="disabled" icon="times-circle" size="lg" v-else>
            </font-awesome-icon>
        </span>
        <span class="td" v-if="$store.getters.isAdmin">
            <div class="operations">


<router-link :title="$t('general.edit')" :to="{name: 'edit-user', params: {user: user}}" :user="user"
             v-if="user.username !== currentUsername">
            <svg height="22" viewBox="0 -3 20 23" width="20" xmlns="http://www.w3.org/2000/svg">
                <circle class="a" cx="10"
                        cy="10" r="10"/>
                <path class="b"
                      d="M36.344,29.156H34.922a.17.17,0,0,1-.156-.109,4.869,4.869,0,0,0-.469-1.141.164.164,0,0,1,.016-.187l1-1a.151.151,0,0,0,0-.219L34,25.172a.151.151,0,0,0-.219,0l-1,1a.166.166,0,0,1-.187.031,4.869,4.869,0,0,0-1.141-.469.155.155,0,0,1-.109-.156V24.156A.148.148,0,0,0,31.188,24H29.313a.148.148,0,0,0-.156.156v1.422a.17.17,0,0,1-.109.156,4.869,4.869,0,0,0-1.141.469.164.164,0,0,1-.187-.016l-1-1a.151.151,0,0,0-.219,0L25.172,26.5a.151.151,0,0,0,0,.219l1,1a.166.166,0,0,1,.031.188,4.869,4.869,0,0,0-.469,1.141.155.155,0,0,1-.156.109H24.156a.148.148,0,0,0-.156.156v1.875a.148.148,0,0,0,.156.156h1.422a.17.17,0,0,1,.156.109,4.869,4.869,0,0,0,.469,1.141.164.164,0,0,1-.016.188l-1,1a.151.151,0,0,0,0,.219l1.328,1.328a.151.151,0,0,0,.219,0l1-1a.166.166,0,0,1,.187-.031,4.869,4.869,0,0,0,1.141.469c.062.016.094.094.094.172v1.406a.161.161,0,0,0,.172.156H31.2c.094,0,.141-.062.141-.156V34.938a.207.207,0,0,1,.125-.172,4.869,4.869,0,0,0,1.141-.469.164.164,0,0,1,.187.016l1,1a.151.151,0,0,0,.219,0l1.328-1.328a.151.151,0,0,0,0-.219l-1-1a.166.166,0,0,1-.031-.187,4.755,4.755,0,0,0,.469-1.125.155.155,0,0,1,.156-.109h1.422c.078.016.141-.062.141-.156V29.313A.148.148,0,0,0,36.344,29.156ZM30.25,33.063a2.813,2.813,0,1,1,2.813-2.812A2.821,2.821,0,0,1,30.25,33.063Z"
                      transform="translate(-20.25 -20.25)"/></svg>
        </router-link>
                <router-link :title="$t('general.edit')" :to="{name: 'account-edit'}" v-else>
                                <svg height="22" viewBox="0 -3 20 23" width="20" xmlns="http://www.w3.org/2000/svg">
                <circle class="a" cx="10"
                        cy="10" r="10"/>
                <path class="b"
                      d="M36.344,29.156H34.922a.17.17,0,0,1-.156-.109,4.869,4.869,0,0,0-.469-1.141.164.164,0,0,1,.016-.187l1-1a.151.151,0,0,0,0-.219L34,25.172a.151.151,0,0,0-.219,0l-1,1a.166.166,0,0,1-.187.031,4.869,4.869,0,0,0-1.141-.469.155.155,0,0,1-.109-.156V24.156A.148.148,0,0,0,31.188,24H29.313a.148.148,0,0,0-.156.156v1.422a.17.17,0,0,1-.109.156,4.869,4.869,0,0,0-1.141.469.164.164,0,0,1-.187-.016l-1-1a.151.151,0,0,0-.219,0L25.172,26.5a.151.151,0,0,0,0,.219l1,1a.166.166,0,0,1,.031.188,4.869,4.869,0,0,0-.469,1.141.155.155,0,0,1-.156.109H24.156a.148.148,0,0,0-.156.156v1.875a.148.148,0,0,0,.156.156h1.422a.17.17,0,0,1,.156.109,4.869,4.869,0,0,0,.469,1.141.164.164,0,0,1-.016.188l-1,1a.151.151,0,0,0,0,.219l1.328,1.328a.151.151,0,0,0,.219,0l1-1a.166.166,0,0,1,.187-.031,4.869,4.869,0,0,0,1.141.469c.062.016.094.094.094.172v1.406a.161.161,0,0,0,.172.156H31.2c.094,0,.141-.062.141-.156V34.938a.207.207,0,0,1,.125-.172,4.869,4.869,0,0,0,1.141-.469.164.164,0,0,1,.187.016l1,1a.151.151,0,0,0,.219,0l1.328-1.328a.151.151,0,0,0,0-.219l-1-1a.166.166,0,0,1-.031-.187,4.755,4.755,0,0,0,.469-1.125.155.155,0,0,1,.156-.109h1.422c.078.016.141-.062.141-.156V29.313A.148.148,0,0,0,36.344,29.156ZM30.25,33.063a2.813,2.813,0,1,1,2.813-2.812A2.821,2.821,0,0,1,30.25,33.063Z"
                      transform="translate(-20.25 -20.25)"/></svg>
                </router-link>
                <button :title="$t('general.remove')" @click="removeUser" v-if="user.username !== currentUsername">
<font-awesome-icon class="disabled" icon="times-circle" size="lg"></font-awesome-icon>
</button>
</div>
        </span>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {

  name: 'User',
  components: {
    Multiselect,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: false,
    },
  },
  computed: {
    isActive() {
      return this.user.status;
    },
    groups() {
      const result = Object.keys(this.user.groups)
        .map(key => ({
          id: Number(key),
          name: this.user.groups[key],
        }));
      return result;
      // return this.user.groups;
    },
    currentUsername() {
      const { user } = this.$store.getters;
      return user.username;
    },
  },
  data() {
    return {
      selectValue: [],
    };
  },
  methods: {
    removeUser() {
      this.$emit('removal', this.user);
    },
  },
};
</script>

<style lang="scss" scoped>

    DIV.table {
        display: table;
    }

    FORM.tr, DIV.tr {
        display: table-row;
        /*border: 1px solid lightgray;*/
    }

    SPAN.td {
        display: table-cell;
        padding: 20px;
        border-bottom: 1px solid $border-gray;
        border-right: 1px solid $border-gray;
        // color: $baseTextColor;
        text-align: left;

        &:first-child {
            font-weight: 900;
        }

        &:last-child {
            border-right: none;
        }

        input {
            border: none;
        }
    }

    .a {
        fill: $marine-blue;
    }

    .b {
        fill: $white;
    }

    svg {
        padding: 0 10px 0 20px;
    }

    .active {
        color: $peacock-blue;
    }

    .disabled {
        color: $marine-blue;
    }

    .td.status {
        text-align: center;
    }

    .operations {
        display: flex;
        align-items: center;
    }

    button {
        border: none;
        box-shadow: none;
        background: none;

    }
</style>
